import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { CategoryListComponent } from "./category-list/category-list.component";

const routes: Routes = [
  {
    path: "categories",
    component: CategoryListComponent,
    canActivate: [AuthGuard],
  },
];

export const CategoriesRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/categories.routes.ts